import { Box, Stack } from "@origin-digital/ods-core";
import React, { useContext, useEffect } from "react";
import { fromMessageRestsToMessageRecords } from "./helpers";

import { IMessageRest } from "./types";
import { apiClient } from "../../../api/apiService";
import ActionButtons from "./MessageActionButtons";
import FileTypeDialog from "./MessageFileUploadDialog";
import MessageInput from "./MessageInput";
import { MessageContext } from "./MessageContext";
import MessageRecordList from "./MessageRecordList";

const MessagesTabContent = () => {
  const { messageTabState, setMessageTabState } = useContext(MessageContext);
  const { requestId, blockRefId, journeyId, showDocumentTypeDialog, type } =
    messageTabState;
  useEffect(() => {
    fetchMessages();
  }, [journeyId, requestId]);

  const fetchMessages = async () => {
    const id = blockRefId === "internet-block" ? requestId : journeyId;
    if (id) {
      try {
        const getMessagesResponse = await apiClient.get<IMessageRest[]>(
          `/message/messages/${id}`,
          {
            params: { type },
          }
        );
        const messageRecords = fromMessageRestsToMessageRecords(
          getMessagesResponse.data
        );
        setMessageTabState((prevMessageTabState) => ({
          ...prevMessageTabState,
          messageRecords,
          processingMessagesFetched: true,
        }));
        if (messageRecords.length > 0) {
          setMessageTabState((prevMessageTabState) => ({
            ...prevMessageTabState,
            latestMessageProcessed:
              messageRecords[messageRecords.length - 1].processed,
            latestMessageDirection:
              messageRecords[messageRecords.length - 1].direction,
            latestMessageType: messageRecords[messageRecords.length - 1].type,
          }));
        }
      } catch (err) {
        setMessageTabState((prevMessageTabState) => ({
          ...prevMessageTabState,
          displaySnackbar: {
            tone: "critical",
            message: `Failed to fetch messages for ${
              blockRefId === "internet-block" ? "request" : "journey"
            } ${id}`,
          },
        }));
      }
    }
  };

  return (
    <Box paddingTop="medium">
      <Stack space="xxlarge">
        <MessageRecordList />
        <Stack
          space={{
            xs: "medium",
            sm: "large",
          }}
        >
          <MessageInput />
          <ActionButtons fetchMessages={fetchMessages} />
        </Stack>
        {showDocumentTypeDialog && <FileTypeDialog />}
      </Stack>
    </Box>
  );
};

export default MessagesTabContent;
